// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"5d817bfd68e643818935","303":"466a076155f345bb3349","495":"787030a3f218589d8c4b"}[chunkId] + ".js";
};